// @ts-nocheck
import { Hidden } from 'applaus-ui-kit'
import * as S from './BottomNavigation.styles'
import { useHistory, useLocation } from 'react-router-dom'
import { MobileLocationBar } from '../mobileLocationBar/MobileLocationBar'
import {
  MOBILE_BOTTOM_NAV_HEIGHT,
  MOBILE_LOCATION_BAR_HEIGHT
} from '../mobileLocationBar/MobileLocationBar.styles'

type Props = {
  active: 'home' | 'search' | 'purchases' | 'profile'
}

export const MOBILE_LOCATION_BAR_PATHS = ['/', '/search']

export const shouldShowMobileLocationBar = (pathname: string) =>
  MOBILE_LOCATION_BAR_PATHS.includes(pathname)

export const MOBILE_BOTTOM_OFFSET =
  MOBILE_BOTTOM_NAV_HEIGHT + MOBILE_LOCATION_BAR_HEIGHT

export const getMobileBottomOffset = (pathname: string) =>
  shouldShowMobileLocationBar(pathname)
    ? MOBILE_BOTTOM_OFFSET
    : MOBILE_BOTTOM_NAV_HEIGHT

export const BottomNavigation = ({ active }: Props) => {
  const history = useHistory()
  const { pathname } = useLocation()
  const showLocationBar = shouldShowMobileLocationBar(pathname)

  return (
    <Hidden desktop tablet>
      {showLocationBar ? <MobileLocationBar /> : null}
      <S.Container>
        <ul>
          <S.Item
            active={active === 'home' ? 1 : 0}
            onClick={() => history.push('/')}>
            <S.HomeIcon />
          </S.Item>
          <S.Item
            onClick={() => history.push('/search')}
            active={active === 'search' ? 1 : 0}>
            <S.SearchIcon />
          </S.Item>
          <S.Item
            active={active === 'purchases' ? 1 : 0}
            onClick={() => history.push('/purchases')}>
            <S.LikeIcon />
          </S.Item>
          <S.Item
            active={active === 'profile' ? 1 : 0}
            onClick={() => {
              history.push('/profileTab')
            }}>
            <S.ProfileIcon />
          </S.Item>
        </ul>
      </S.Container>
    </Hidden>
  )
}

export const BottomNavigationSpacer = () => (
  <Hidden desktop tablet>
    <div style={{ height: `${MOBILE_BOTTOM_OFFSET}px` }} />
  </Hidden>
)
